var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "StoneCutEmerald",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-stone-cut-emerald","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M170.3-.2H76.9l-40 37.9v168.5l44.7 43.9h94.6l37.8-43.5v-169L170.3-.2zm22.9 187.9V56.5l11.7-8.2v147.6l-11.7-8.2zm-34.3 33.8l-6.4-12 17.8-26.7 12.8 8.9-23.4 29.8h-.8zM56.8 56v132.2l-11 7.7V48.3l11 7.7zm112.3 6.3L151 41.8l6.5-12.2L182 53.2l-12.9 9.1zM147 201.5h-42.2l-19.4-24.8V69l16.9-20.9h42.3l18.5 21v108.1L147 201.5zm-67.6-18.1l18.9 24.2-5.8 10.9-24.8-27 11.7-8.1zm62.9-144.2h-38.8l-5.8-11h50.4l-5.8 11zm10.6-20h-60L87.4 8.8h71l-5.5 10.4zM95.2 42.8L80.1 61.3 68 52.8l20.9-21.9 6.3 11.9zm-18.7 27v104.6l-10.7 7.5V62.3l10.7 7.5zm-16.3 127L88 227l-5.9 11.1L48.5 205l11.7-8.2zm36.1 33.7h57.2l5.7 10.7H90.7l5.6-10.7zm4.8-9l5.8-11h36l5.8 11h-47.6zm71.1-48.4l-.1.1V71l.1.1 11.9-8.3v118.6l-11.9-8.3zM202 39.3L189.6 48l-27.7-26.6 6.2-11.6L202 39.3zM78.3 10.9l6.2 11.7-24 25.1-12.1-8.5 29.9-28.3zm93.6 230.3h-2.6l-5.7-10.7h.4l26.4-33.6 12.4 8.7-30.9 35.6z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/stone-cut-emerald.svg